import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ListApp from "../../modules/booking/pages/BookingListApp";
import Classroom from "../../modules/booking/pages/Classroom/Classroom";
import Request from "../../modules/booking/pages/Request/Request";
import Detail from "../../modules/booking/pages/BookingDetail/BookingDetail";
import { Module, RouteType } from "./types";
import useBookingAccess from "@common/hooks/useBookingAccess";
import BookingListWrapper from "@modules/booking/pages/BookingList/BookingListWrapper";

export const base = "/booking";
const context = ":workspace/:scenario/:origin";
const appContext = ":workspace/:scenario";

const bookingsModule: () => Module = () => ({
  name: "bookings",
  routes: [
    {
      path: `${base}/list/${context}`,
      component: BookingListWrapper,
    },
    {
      path: `${base}/list/${appContext}`,
      component: ListApp,
    },
    {
      path: `${base}/detail/${context}/:id`,
      component: Detail,
    },
    {
      path: `${base}/detail/${appContext}/:id`,
      component: Detail,
    },
    {
      path: `${base}/search/${context}/:id`,
      component: Classroom,
    },
    {
      path: `${base}/search/${context}`,
      component: Classroom,
    },
    {
      path: `${base}/search/${appContext}`,
      component: Classroom,
    },
    {
      path: `${base}/request/${context}/:id`,
      component: Request,
    },
    {
      path: `${base}/request/${context}`,
      component: Request,
    },
    {
      path: `${base}/create/request/${appContext}/:id`,
      component: Request,
    },
    {
      path: `${base}/create/request/${appContext}`,
      component: Request,
    },
  ],
});

const RouteBooking: React.FC = () => {
  const { isBookingAccesible } = useBookingAccess();

  // If the module is not accesible, redirect the user to the home page
  if (!isBookingAccesible) {
    return (
      <Switch>
        <Redirect to="/" />
      </Switch>
    );
  }

  return (
    <Switch>
      {bookingsModule()?.routes?.map((route: RouteType) => (
        <Route key={route.path} path={route.path} component={route.component} />
      ))}
    </Switch>
  );
};

export default RouteBooking;
